import { ShieldCheck, PackageCheck, HeartHandshake } from "lucide-react";
import { Reveal } from "./shared";

const badges = [
  { icon: ShieldCheck, title: "Trained & Insured", text: "Vetted, background-checked cleaners you can trust in your home." },
  { icon: PackageCheck, title: "We Bring Everything", text: "All supplies & eco-friendly products included, at no extra cost." },
  { icon: HeartHandshake, title: "Satisfaction Guaranteed", text: "Not happy with a spot? We'll come back and make it right." },
];

export default function TrustBadges() {
  return (
    <section data-testid="trust-badges" className="bg-white py-20 md:py-24">
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid md:grid-cols-3 gap-8 md:gap-12">
        {badges.map((b, i) => (
          <Reveal key={b.title} delay={i * 0.12}>
            <div className="flex flex-col items-start gap-4" data-testid={`trust-badge-${i}`}>
              <span className="w-14 h-14 rounded-full bg-blush flex items-center justify-center text-teal">
                <b.icon size={26} strokeWidth={1.5} />
              </span>
              <h3 className="font-serif-display text-2xl text-teal">{b.title}</h3>
              <p className="text-teal-soft leading-relaxed">{b.text}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
